import {MoveRight} from "lucide-react";
import {getResiseImageUrl, urlForImage} from "../../sanity/lib/image";
import {useRouter} from "next/router";
import Image from 'next/image';

export interface Offer {
    id: string;
    title: string;
    description: string;
    price: string;
    image: string;
    rate: string;
    slug: any;
}

export default function CardOffer(offer: Offer) {
    const router = useRouter();

    return (
        <div className="card-offer relative bg-gray-800 rounded-lg overflow-hidden shadow-lg">
            {/* Immagine con Next.js <Image> */}
            <div className="relative w-full aspect-[2/3]">
                <Image
                    src={urlForImage(offer.image)}
                    alt={offer.title}
                    width={200} // Specifica le dimensioni reali
                    height={300}
                    layout="responsive"
                    className="rounded-t-lg"
                    placeholder="blur" // Usa una versione sfocata come placeholder
                    blurDataURL={getResiseImageUrl(offer.image, 10, 10)} // Genera immagine sfocata
               />
            </div>

            {/* Contenuto sopra l'immagine */}
            <div className="absolute top-0 left-0 p-4">
                <h2 className="text-lg font-bold text-white drop-shadow-md">{offer.title}</h2>
                <p className="text-sm text-gray-300 drop-shadow-md">{offer.description}</p>
            </div>

            {/* Contenuto in basso */}
            <div className="absolute bottom-0 left-0 p-4 w-full bg-gradient-to-t from-black/70 via-black/30 to-transparent">
                <p className="price text-xl font-bold text-white">{offer.price}</p>
                <p className="rate text-sm text-gray-300">{offer.rate}</p>
                <button
                    onClick={() => {
                        offer.slug && router.push(`/offerta-last-minute/${offer.slug.current}`);
                    }}
                    className="mt-2 text-primary font-bold bg-white rounded-md flex gap-3 items-center justify-center w-full py-2 shadow-md hover:bg-gray-100 transition"
                >
                    Scopri
                    <MoveRight strokeWidth={1} />
                </button>
            </div>
        </div>
    );

}
